import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Input,
  Container,
  Segment,
  Table,
  Grid,
  Loader,
  Dropdown
} from 'semantic-ui-react'


import titleCase from 'title-case'

import './Sections.css'
import PaginationTable from '../../components/PaginationTable/PaginationTable'
import SectionsAdd from './SectionsAdd'
import SectionsView from './SectionsView'
import SectionsEdit from './SectionsEdit'
import SectionsDelete from './SectionsDelete'

const changeCase = {
    titleCase: titleCase
}

const SectionsPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar') {
    const { activePage, itemPerPage, column, direction, data, searchKey, fields, loaded, teachers, schoolYearId } = props;
    if (!props.currentSchoolYear) return null;
    let currentData = data.filter(props.isSearched(searchKey));
    const indexOfLast = activePage * itemPerPage;
    const indexOfFirst = indexOfLast - itemPerPage;
    const rowLength = currentData.length;
    currentData = currentData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(rowLength / itemPerPage);

    const sectionTable = currentData.map((section, key )=> {
      const teacherName = section.teacher ? 
        section.teacher.firstName + ' ' + section.teacher.lastName : 
        'No Teacher Assigned';
      return (
        <Table.Row key={key} className='sections-table-row'>
          <Table.Cell>{section.gradeLevel}</Table.Cell>
          <Table.Cell>{section.name}</Table.Cell>
          <Table.Cell>{section.levelType}</Table.Cell>
          <Table.Cell>{teacherName}</Table.Cell>
          <Table.Cell collapsing>
            <SectionsView
              section={section}
              teachers={teachers}
              students={props.students}
              sectionStudents={props.sectionStudents}
              getSectionStudents={props.getSectionStudents}
              handleDeleteSectionStudent={props.handleDeleteSectionStudent}
              handleSubmitSectionStudent={props.handleSubmitSectionStudent}

              subjects={props.subjects}
              sectionSubjects={props.sectionSubjects}
              getSectionSubjects={props.getSectionSubjects}
              handleDeleteSectionSubject={props.handleDeleteSectionSubject}
              handleSubmitSectionSubject={props.handleSubmitSectionSubject}
              handleUpdateSectionSubject={props.handleUpdateSectionSubject}
              handleFileChange={props.handleFileChange}
              handleDataSaveStudents={props.handleDataSaveStudents}
              handleDataSaveSubjects={props.handleDataSaveSubjects}
            />
            <SectionsEdit
              section={section}
              teachers={teachers}
              handleUpdate={props.handleUpdate}
            />

            <SectionsDelete
              sectionId={section.sectionId}
              sectionName={section.name}
              handleDelete={props.handleDelete}
            />
          </Table.Cell>
        </Table.Row>
      );
    });

    let headers = fields.map((field,index) => {
      return (
        <Table.HeaderCell
          key={index}
          sorted={column === field ? direction : null}
          onClick={() => props.handleSort(field)}
          textAlign='center'
        >
          {changeCase.titleCase(field)}
        </Table.HeaderCell>
      )
    });

    let optionsSchoolYears;
    if (props.schoolYears) {
      optionsSchoolYears = props.schoolYears.map((schoolYear,index) => {
        return (
            { key: schoolYear.schoolYearId, value: schoolYear.schoolYearId, text: schoolYear.name }
        )
      })
    }

    return (
      <div>
        <Container>
          <Segment>
            <Grid>
              <Grid.Column floated='left' width={8}>
                <Grid.Column width={4}>
                  <Input
                    icon='search'
                    value={searchKey}
                    onChange={props.onSearchChange}
                    placeholder='Search Sections'
                  />
                </Grid.Column>
              </Grid.Column>
              <Grid.Column width={8}>
                <SectionsAdd
                  teachers={teachers}
                  schoolYearId={schoolYearId}
                  handleSubmit={props.handleSubmit}
                />
              </Grid.Column>
            </Grid>
            <Grid centered columns={5}>
              <Grid.Column>
                <Dropdown
                  selection
                  options={optionsSchoolYears}
                  onChange={props.handleChange}
                  value={schoolYearId}
                />
              </Grid.Column>
            </Grid>
            {
              loaded ?
              <div className='table-sections'>
                {
                  data.length > 0 ?
                  <Table celled selectable sortable striped size='small'>
                    <Table.Header>
                      <Table.Row>
                        {headers}
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>{sectionTable}</Table.Body>
                      {
                        data.length > itemPerPage ?
                        <PaginationTable
                          onPageChange={props.handlePaginationChange}
                          totalPages={totalPages}
                          activePage={activePage}
                          fields={fields}
                        >

                        </PaginationTable>
                        :
                        null
                      }
                  </Table>
                  :
                  <Segment>No section records found.</Segment>
                }
              </div>
              :
              <Loader active inline='centered' />
            }

          </Segment>
        </Container>
      </div>
    )
  } else {
    return <Segment>You are not authorized to be in this page.</Segment>
  }
  } else {
    return <Redirect to='/' />
  }

}

export default SectionsPV;
